/** Shared workflow card geometry for connector alignment. */
export const WORKFLOW_CARD_WIDTH = 340;
export const WORKFLOW_MAIN_CARD_WIDTH = WORKFLOW_CARD_WIDTH;
export const WORKFLOW_MAIN_CARD_CENTER_X = WORKFLOW_MAIN_CARD_WIDTH / 2;
export const WORKFLOW_CARD_GAP = 16;
export const WORKFLOW_MAIN_COLUMN_WIDTH = WORKFLOW_MAIN_CARD_WIDTH;

export function getCardCenterX(width = WORKFLOW_MAIN_COLUMN_WIDTH) {
  return width / 2;
}

export function getCardTopCenter(width = WORKFLOW_MAIN_COLUMN_WIDTH) {
  return { x: getCardCenterX(width), y: 0 };
}

export function getCardBottomCenter(width = WORKFLOW_MAIN_COLUMN_WIDTH) {
  return { x: getCardCenterX(width), y: 0 };
}

export function getTriggerRowWidth(count) {
  if (count <= 0) return 0;
  return count * WORKFLOW_CARD_WIDTH + (count - 1) * WORKFLOW_CARD_GAP;
}

/** Offset for centering a trigger row wider than the main column. */
export function getTriggerRowOffset(triggerRowWidth) {
  return (WORKFLOW_MAIN_COLUMN_WIDTH - triggerRowWidth) / 2;
}

/** Map main-column center X into trigger-row SVG coordinates. */
export function getMainCenterInRowCoords(triggerRowWidth) {
  return getCardCenterX(WORKFLOW_MAIN_COLUMN_WIDTH) - getTriggerRowOffset(triggerRowWidth);
}
